import { render, staticRenderFns } from "./index_oferta.vue?vue&type=template&id=3c4a1b90&scoped=true"
import script from "./index_oferta.vue?vue&type=script&lang=js"
export * from "./index_oferta.vue?vue&type=script&lang=js"
import style0 from "./index_oferta.vue?vue&type=style&index=0&id=3c4a1b90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4a1b90",
  null
  
)

export default component.exports